module.exports = __webpack_public_path__ + "static/media/phone-bg.7bc0cb54.png";